import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import JdbcWriterForm from '../forms/jdbc-writer-form';
import { jdbcWriterValidationSchema } from '../schema/jdbcWriter.js';

export default function JdbcWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'JDBC Writer Node Details',
        altText: 'JDBC Writer Node',
        defaultLabel: 'JDBC Writer Node',
      }}
    >
      <CommonNode FormComponent={JdbcWriterForm} schemaResolver={jdbcWriterValidationSchema} />
    </NodeProvider>
  );
}
